import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Approvals() {
  const [pending, setPending] = useState({ scripts: [], monthly_plans: [] });
  const [all, setAll] = useState([]);

  const load = () => {
    api.get("/approvals/pending").then((r) => setPending(r.data));
    api.get("/approvals").then((r) => setAll(r.data));
  };
  useEffect(() => { load(); }, []);

  const decide = async (target_type, target_id, target_version, decision) => {
    await api.post("/approvals", { target_type, target_id, target_version: target_version || 1, decision, comment: "" });
    toast.success("Decision recorded");
    load();
  };

  return (
    <div className="p-8 max-w-[1400px]">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold mb-1">Approvals</div>
        <h1 className="text-5xl font-black tracking-tight leading-none" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Founder queue</h1>
      </div>

      <section className="mb-8">
        <h2 className="text-xl font-black tracking-tight mb-3" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Scripts</h2>
        {pending.scripts.length === 0 && <div className="text-sm text-neutral-500">Nothing pending.</div>}
        {pending.scripts.map((s) => (
          <div key={s.id} data-testid={`approval-script-${s.id}`} className="bg-white border border-neutral-200 rounded-lg p-4 mb-2">
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold">v{s.version} · {s.approval_status}</div>
                <div className="font-bold text-lg" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>{s.title}</div>
                <div className="text-sm text-neutral-600 line-clamp-2 mt-1">{s.spoken_script}</div>
              </div>
              <div className="flex gap-2 shrink-0">
                <button data-testid={`app-approve-${s.id}`} onClick={() => decide("script", s.id, s.version, "approved")} className="text-xs font-semibold px-3 py-2 rounded text-neutral-900" style={{ background: "#D4FF00" }}>Approve</button>
                <button data-testid={`app-changes-${s.id}`} onClick={() => decide("script", s.id, s.version, "changes_requested")} className="text-xs font-semibold px-3 py-2 rounded border border-neutral-300 hover:bg-neutral-50">Changes</button>
                <button data-testid={`app-reject-${s.id}`} onClick={() => decide("script", s.id, s.version, "rejected")} className="text-xs font-semibold px-3 py-2 rounded border border-red-300 text-red-700 hover:bg-red-50">Reject</button>
              </div>
            </div>
          </div>
        ))}
      </section>

      <section>
        <h2 className="text-xl font-black tracking-tight mb-3" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Approval history</h2>
        {all.slice(0, 20).map((a) => (
          <div key={a.id} className="text-sm border-b border-neutral-100 py-2 flex justify-between">
            <div>{a.target_type} #{a.target_id?.slice(0, 8)} — <span className="font-semibold">{a.decision}</span> by {a.reviewer_name}</div>
            <div className="text-xs text-neutral-500">{a.created_at?.slice(0, 16)}</div>
          </div>
        ))}
      </section>
    </div>
  );
}
